/** Default approval workflow shape for Declaration / Proof Submission. */

export const DEFAULT_WORKFLOW = {
  approvalMethod: "auto_approved",
  workflowSteps: [],
};

export function normalizeWorkflow(raw) {
  if (!raw || typeof raw !== "object") {
    return { ...DEFAULT_WORKFLOW, workflowSteps: [] };
  }
  const method =
    raw.approvalMethod === "workflow" ? "workflow" : "auto_approved";
  const steps = Array.isArray(raw.workflowSteps)
    ? raw.workflowSteps.map((s, i) => ({
        role: s?.role || "",
        slaDays: Number(s?.slaDays) > 0 ? Number(s.slaDays) : 3,
        notifyOnly: !!s?.notifyOnly,
        order: i + 1,
      }))
    : [];
  return {
    approvalMethod: method,
    workflowSteps: steps,
  };
}

export function validateWorkflow(workflow, label = "Workflow") {
  const w = normalizeWorkflow(workflow);
  if (w.approvalMethod !== "workflow") return { ok: true, workflow: w };
  if (!w.workflowSteps.length) {
    return {
      ok: false,
      message: `${label}: add at least one approval step, or choose Auto approved.`,
    };
  }
  const missing = w.workflowSteps.find((s) => !String(s.role || "").trim());
  if (missing) {
    return {
      ok: false,
      message: `${label}: each step must have a role selected.`,
    };
  }
  return { ok: true, workflow: w };
}
